import { OrdersApiService } from '../services/orders.api.service';
import { OrderModel } from '../models/order.model';

/**
 * Check if customer is first time customer.
 * The function will fetch the customer's orders and check if there is only one order.
 * @param { number | null | undefined } customerId The customer id.
 */
export async function isFirstTimeCustomer(customerId) {
  let isFirstTimeCustomer = false;

  if (!customerId) {
    // the customer is not registered (`id` is `null`)
    return isFirstTimeCustomer;
  }

  // if we have a customer id, check if it is a first time customer
  try {
    // fetch the customer's orders and check if there is only one -> is first time customer
    const response = await OrdersApiService.getAll(builder => {
      builder.whereEquals(OrderModel.ATTR_CUSOTMER_ID, customerId);
      builder.setPerPage(2); // we only need 2 orders at most to decide whether the customer is a new one or not
    });
    isFirstTimeCustomer = response.getItems().length === 1;
  } catch (error) {
    console.error(error);
  }

  return isFirstTimeCustomer;
}
